
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import moment from 'moment';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Impferinnerungsbrief from '@/types/Impferinnerungsbrief';
    import { Geschlecht } from '@/types/Geschlecht';
    import { ValidationRules } from '@/store/types';
    import { VForm } from '@/types/Components';
    import Impfstelle from '@/types/Impfstelle';
    import { PrintBriefPayload } from '@/store/impferinnerungen';
    import { SystemEinstellung, SystemEinstellungKey } from '@/types/Einstellung';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules', 'formatDate', 'parseDate']),
            ...mapState('patient', ['patientData']),
            ...mapState('authentication', ['impfstelle_id']),
            ...mapGetters('authentication', ['impfstelleDetail', 'getSystemEinstellung']),
            ...mapState('impferinnerungen', ['loaders', 'brief']),
            ...mapGetters('personen', ['getPersonen']),
            ...mapState('personen', { personenLoaders: 'loaders' }),
        },
        methods: {
            ...mapActions('impferinnerungen', ['printBrief']),
            ...mapActions('personen', ['loadPersonen']),
            ...mapMutations('patient', ['setDialogRezept']),
        },
    })
    export default class ImpferinnerungsbriefDetail extends Vue {
        @Prop() visible!: boolean;

        public $refs!: {
            form: VForm;
            text: Vue;
        };

        public rules!: ValidationRules;
        public brief!: Impferinnerungsbrief;
        public impfstelle_id!: number
        public impfstelleDetail!: Impfstelle
        public printBrief!: (payload: PrintBriefPayload) => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;

        public data = new Impferinnerungsbrief();
        public text = '';
        public textErrorMessage = '';

        public get briefTitel(): string {
            if (!this.data) return '';

            return this.data.geschlecht === Geschlecht.Maennlich
                ? 'Herr'
                : this.data.geschlecht === Geschlecht.Weiblich
                    ? 'Frau '
                    : '';
        }

        public get briefOrtDatum(): string {
            return `${this.getSystemEinstellung('brief_ortsname').toString()}, ${moment().format('DD. MMMM YYYY')}`;
        }

        @Watch('brief.patimpfung_id')
        public onChangeVisible(visible: boolean): void {
            if (!visible) return;

            this.resetValidation();

            this.data = new Impferinnerungsbrief(this.brief);

            this.textErrorMessage = '';

            if (this.data.brief === null) {
                this.data.brief = '';
            }

            this.text = '';
        }

        public resetValidation(): void {
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        }

        public validateText(): void {
            this.textErrorMessage = '';

            if (this.data.brief === '<p></p>') {
                this.data.brief = '';
            }

            for (const rule of [this.rules.required]) {
                const result = rule(this.data.brief);
                if (result !== true) {
                    this.textErrorMessage = result as string;
                }
            }
        }

        public onClickPrint(isExport: boolean): void {
            this.validateText();

            if (!this.$refs.form.validate() || this.textErrorMessage !== '') {
                return;
            }

            this.printBrief({
                briefe: [this.data.patimpfung_id as number],
                text: this.data.brief ?? '',
                export: isExport,
                name: [this.data.vorname, this.data.nachname].filter((x) => x).join(' '),
            });
        }

        public onClickClose(): void {
            this.resetValidation();
            this.$emit('close');
        }

        public get textLabelClass(): string {
            return this.textErrorMessage === ''
                ? 'primary--text'
                : 'red--text';
        }
    }
